import React from 'react';
import { useFeatureFlag, useFeatureFlags } from '../../hooks/useFeatureFlag';

interface FeatureFlagWrapperProps {
  flag?: string; // Single flag (for backward compatibility)
  flags?: string[]; // Multiple flags with OR logic
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const FeatureFlagWrapper: React.FC<FeatureFlagWrapperProps> = ({
  flag,
  flags,
  children,
  fallback = null,
}) => {
  // Support both single flag and multiple flags
  // If flags array is provided, use OR logic (any flag enabled = show feature)
  // Otherwise, use single flag (backward compatible)
  const isEnabled = flags 
    ? useFeatureFlags(flags)
    : flag 
      ? useFeatureFlag(flag)
      : false;

  if (!isEnabled) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

